"use client";
import Link from "next/link";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";
import { giftCardRoute } from "@/utils/giftCardUtils";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "@/utils/localStorageUtils";
import { ScanToOrderInfo } from "@/dto/scanToOrderInfo";
import { LocalStorageKey } from "@/utils/storageKeys";
import { useRouter } from "next/navigation";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export interface CheckoutCartHeaderProps {
  redirectToGiftCard: boolean;
  isRunningTabsEnabled: boolean;
}

export const CheckoutHeader = ({
  redirectToGiftCard,
  isRunningTabsEnabled,
}: CheckoutCartHeaderProps) => {
  const router = useRouter();
  const scanToOrderInfo = getFromLocalStorage<ScanToOrderInfo | null>(
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    null
  );

  const clearScanToOrderCart = () => {
    if (scanToOrderInfo && isRunningTabsEnabled) {
      removeFromLocalStorage(LocalStorageKey.CART);
    }
  };

  const handleBackClick = () => {
    clearScanToOrderCart();
    router.back();
  };

  return (
    <div
      data-testid={applyDataTestId(pom.checkout.checkoutHeader)}
      className={[
        "hidden",
        "sm:flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        {!redirectToGiftCard && (
          <button type="button" onClick={handleBackClick}>
            <div
              className={["flex", "flex-row", "gap-3", "items-center"].join(
                " "
              )}
            >
              <ArrowLeftIcon />
              <p className="text-[20px] font-medium text-[#373737]">Checkout</p>
            </div>
          </button>
        )}
        {redirectToGiftCard && (
          <Link href={giftCardRoute} onClick={clearScanToOrderCart}>
            <div
              className={["flex", "flex-row", "gap-3", "items-center"].join(
                " "
              )}
            >
              <ArrowLeftIcon />
              <p className="text-[20px] font-medium text-[#373737]">Checkout</p>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};
